import { createSlice } from '@reduxjs/toolkit';

import { OrderProps } from './orders.types';

const initialState: OrderProps = {
  _id: '',
  createdAt: '',
  email: '',
  id: '',
  insurance: {
    memberId: '',
    pcn: '',
    relationship: '',
    rxBin: '',
    rxGroup: ''
  },
  maxioLink: '',
  metadata: {
    createdAt: '',
    createdBy: '',
    version: 0
  },
  orderStatus: '',
  patient: '',
  prescriptions: [],
  status: '',
  type: ''
};

const orderSlice = createSlice({
  initialState: {
    orderDetails: initialState
  },
  name: 'order',
  reducers: {
    resetOrderDetails: (state) => {
      state.orderDetails = initialState;
    },
    setOrderDetails: (state, action) => {
      state.orderDetails = action.payload;
    }
  }
});

export const { resetOrderDetails, setOrderDetails } = orderSlice.actions;

export default orderSlice.reducer;
